import { Mode } from "~/types";
import { FONTS } from "~/data/partner_config";

export function classNames(
  ...classNames: (string | null | undefined)[]
): string {
  return classNames.filter((value) => value).join(" ");
}

export const getFonts = (mode?: Mode, clientIdPrefix?: string): string[] => {
  if (mode === "rnr") {
    return [...FONTS.rnr];
  }
  return FONTS.default;
};

export function getPrefixFromClientId(clientId: string): string {
  const parts = clientId.split("-");
  return parts.slice(0, -1).join("-") || parts[0];
}
